import React from 'react';
import { View } from '@amzn/atoz-web/View';
import { Spinner, SpinnerSize } from '@amzn/atoz-web/Spinner';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var SpinnerOverlay = function (_a) {
    var isLoading = _a.isLoading, children = _a.children;
    return (React.createElement(Wrapper, { role: "presentation" },
        isLoading && (React.createElement(SpinnerContainer, { alignItems: "center", justifyContent: "center" },
            React.createElement(Spinner, { dataTestId: "SpinnerOverlay", size: SpinnerSize.Medium }))),
        children));
};
var Wrapper = styledWithTheme(View)(function () { return "\n        position: relative;\n    "; });
var SpinnerContainer = styledWithTheme(View)(function (_a) {
    var theme = _a.theme;
    return "\n        display: flex;\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        background: ".concat(theme.selectors.color('neutral0-alpha50'), ";\n        z-index: ").concat(theme.selectors.zIndex('alert'), ";\n    ");
});
